import {Component, HostListener, Signal, viewChild} from '@angular/core';
import {CustomCellEditorComponent} from '../custom-cell-editor/custom-cell-editor.component';
import {ICellEditorParams} from 'ag-grid-community';
import {
  SelectElementComponent
} from '../../../form-control/dynamic-form/form-element/select-element/select-element.component';
import {
  ISelectFormElement,
  ISelectFormOption
} from '../../../form-control/dynamic-form/form-element/form-data.interface';

interface IEnumCellEditorParams extends ICellEditorParams {
  isMulti: boolean;
}

@Component({
  selector: 'app-enum-cell-editor',
  templateUrl: './enum-cell-editor.component.html',
  styleUrls: ['./enum-cell-editor.component.scss'],
  standalone: true,
  imports: [SelectElementComponent],
})
export class EnumCellEditorComponent extends CustomCellEditorComponent {
  selectionElement: Signal<SelectElementComponent> = viewChild<SelectElementComponent>(SelectElementComponent);

  selectElementData: ISelectFormElement;

  override params: IEnumCellEditorParams;

  @HostListener('document:click', ['$event'])
  protected override clickOut(event: MouseEvent): void {
    const target: HTMLElement = event.target as HTMLElement;

    // Check if the click was inside the mat-select panel
    const matSelectPanel: Element = target.closest('[id^="mat-select-"][id$="-panel"]');
    if (matSelectPanel) {
      return;
    }

    // Check if the click was on the editor element
    if (this._elementRef.nativeElement.contains(target)) {
      return;
    }

    this.params?.api?.stopEditing();
  }

  override agInit(params: IEnumCellEditorParams): void {
    this.selectElementData = {
      options: (params.colDef as any).repository.map((o: any, i: number) => {
        return {
          name: o, value: i
        } as ISelectFormOption
      }),
      createNewEnabled: false,
      emptyOptionAdded: false,
      multiple: params.isMulti,
      confirmButton: params.isMulti,
    };
    super.agInit(params);
  }

  override ngAfterViewInit(): void {
    setTimeout((): void => {
      if (!this.params.isMulti) {
        // If single select keep the default behavior
        this.selectionElement().selector.openedChange.subscribe((opened: boolean): void => {
          if (!opened) {
            this.params?.api?.stopEditing();
          }
        });
      }
      this.selectionElement().selector.open();
    });
  }

  compareWith: (e1: any, e2: any) => boolean = (e1: any, e2: any): boolean => {
    return e1 != null && e2 != null && e1 === e2;
  };

  override isPopup(): boolean {
    return false;
  }

  override getValue(): any {
    return super.getValue();
  }

  protected override setPastedValue(pasted: string): void {
    try {
      const patchValue = this.selectElementData.multiple ? JSON.parse(pasted) : Number(JSON.parse(pasted));
      this.textFormControl.patchValue(patchValue);
      this.params.value.value = patchValue;
    } catch (e) {
      console.error(e);
    } finally {
      this.params.api.stopEditing();
    }
  }


  override saveValue() {
    const colDef: any = this.params.colDef;
    // When it's a multiselect, take the first element of the array.
    const value = this.textFormControl.value;

    // Update params.value immediately before the API call
    this.params.value.value = value;

    this.changeLine(
      this.params.data.apiRow.obj,
      this.params.data.apiRow.rowidx,
      colDef.attribute,
      colDef.attributeindex,
      value,
    ).subscribe((): void => {
      if (this.params.isMulti) {
        this.selectionElement().selector.open();
      }
    });
  }

  onConfirm(): void {
    this.params?.api?.stopEditing();
  }
}
